function durString(dur) {
    const minutes = `${Math.floor(dur / 60)}`;
    let seconds = `${dur - minutes * 60}`;

    if (seconds.length < 2) {
        seconds = '0' + seconds;
    }

    return `${minutes}:${seconds}`;
}

class CompositionFile {
    constructor(data) {
        this.data = data;
    }

    name() {
        return this.data.name || '';
    }

    url() {
        return this.data.url;
    }

    fileType() {
        return this.data.url.replace(/^.*\.(\w+)$/, "$1");
    }

    size() {
        const factor = 1024;
        const units  = ['bytes', 'KB', 'MB', 'GB'];

        let size = this.data.size;
        let idx  = 0;
        let unit = units[idx];

        while ((size > factor) && (idx < units.length)) {
            idx++;
            size = size / factor;
            unit = units[idx];
        }

        return `${size.toFixed(1)} ${unit}`;
    }
}

class CompositionMovement {
    constructor(data) {
        this.data = data;
    }

    number() {
        return this.data.number;
    }

    name() {
        return this.data.name;
    }

    durationString() {
        return durString(this.data.duration || 0);
    }
}

class Composition {
    constructor(data) {
        this.data = data;

        this._fileGrps = data.files.map((item) => {
            return item.map((fileData) => {
                return new CompositionFile(fileData);
            });
        });
        this._mvmts = (data.movements || []).map((data) => {
            return new CompositionMovement(data);
        });
    }

    id() {
        return this.name();
    }

    name() {
        return this.data.name;
    }

    durationString() {
        return durString(this.data.duration || 0);
    }

    year() {
        return `${this.data.year}`;
    }

    description() {
        return this.data.description || '';
    }

    fileGroups() {
        return this._fileGrps;
    }

    movements() {
        return this._mvmts;
    }
}

export default Composition;
